import * as React from "react";
const SvgRestore = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 9.333c-.367 0-.68-.13-.941-.392A1.282 1.282 0 0 1 6.667 8c0-.367.13-.68.392-.942.26-.26.574-.391.941-.391s.68.13.942.391c.26.261.391.575.391.942s-.13.68-.391.941A1.284 1.284 0 0 1 8 9.333ZM8 14c-1.389 0-2.617-.417-3.683-1.25A5.87 5.87 0 0 1 2.2 9.533a.701.701 0 0 1 .109-.608.618.618 0 0 1 .524-.258c.156 0 .298.055.426.166a.822.822 0 0 1 .258.4 4.393 4.393 0 0 0 1.633 2.475c.833.64 1.783.959 2.85.959 1.3 0 2.403-.453 3.308-1.359.906-.905 1.359-2.008 1.359-3.308 0-1.3-.453-2.403-1.359-3.309C10.403 3.786 9.3 3.333 8 3.333a4.5 4.5 0 0 0-2.15.534 4.954 4.954 0 0 0-1.683 1.466h1.166c.19 0 .348.064.476.192A.647.647 0 0 1 6 6a.645.645 0 0 1-.191.475.646.646 0 0 1-.476.192H2.667a.643.643 0 0 1-.475-.192A.643.643 0 0 1 2 6V3.333c0-.189.064-.347.192-.475a.645.645 0 0 1 .475-.191c.189 0 .347.063.475.191a.647.647 0 0 1 .191.475v.9a5.82 5.82 0 0 1 2.076-1.65A5.952 5.952 0 0 1 8 2a5.81 5.81 0 0 1 2.342.475 6.11 6.11 0 0 1 1.9 1.283c.539.54.966 1.172 1.283 1.9A5.81 5.81 0 0 1 14 8c0 .833-.158 1.614-.475 2.341a6.1 6.1 0 0 1-1.283 1.9c-.54.54-1.172.967-1.9 1.284A5.81 5.81 0 0 1 8 14Z"
      fill="#091E42"
    />
  </svg>
);
export default SvgRestore;
